/* eslint-disable max-lines */
import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'Wstecz',
      changePassword: 'Zmień hasło',
      copiedVaultId: 'Skopiowane!',
      copyVaultID: 'Kopiuj ID Vaulta',
      create: 'Utwórz',
      next: 'Dalej',
      notSure: 'Nie mam pewności',
      signUp: 'Zarejestruj się',
      submit: 'Prześlij',
      updatePassword: 'Aktualizuj hasło',
    },
    Errors: {
      createReportFailed: 'Nie udało się utworzyć zgłoszenia.',
    },
    ReportStatus: {
      CLOSED: 'Zamknięto',
      INVESTIGATING: 'W trakcie rozpatrywania',
      NEW: 'Przesłano',
      READ: 'Odczytano',
    },
    general: {
      navbar: {
        caseSettings: 'Ustawienia obudowy',
        changePassword: 'Zmień hasło',
        logOut: 'Wyloguj się',
        notifications: 'Powiadomienia',
        notificationsDrawer: {
          appFileScanFailed: 'Plik nie przeszedł kontroli bezpieczeństwa',
          appReportMatch: 'Twój rekord GoTogether został dopasowany',
          appReportReassigned:
            'Nowy menedżer ds. przypadków został przydzielony.',
          case: 'Sprawa',
          caseAssigned: 'Przypadek przypisany do Ciebie',
          caseImporterJobCompleted: {
            PartialSuccess: 'Importowanie Twojej sprawy zakończyło się błędami',
            failure: 'Twój import sprawy nie powiódł się',
            success: 'Import Twojego przypadku zakończył się sukcesem',
          },
          caseLinked: 'Przypadek połączony',
          caseTeamInvite: 'Dodano do sprawy',
          caseUnlinked: 'Sprawa rozłączona',
          dataSanitisation: 'Szczegóły raportu zaktualizowane',
          emptyDescription: 'Sprawdź później nowe powiadomienia',
          emptyTitle: 'Jesteś na bieżąco',
          importId: 'ID importu:',
          learnMore: 'Dowiedz się więcej',
          markAllAsRead: 'Oznacz wszystko jako przeczytane',
          newMessage: 'Nowa wiadomość',
          newReport: 'Otrzymano nowy raport',
          permissionRemoved: 'Usunięty z przypadku',
          postSSubmissionFile: 'Dodano plik(i) dowodowe',
          report: 'Raport',
          reportAssigned: 'Raport przypisany do Ciebie',
          reportStatusChange: 'Status raportu zmieniony',
          reporterAnonymised: 'Twoje dane zostały zanonimizowane',
          reporterReportSubmitted: {
            subtitle: 'Zalecamy zachowanie kopii swojego raportu',
            title: 'Zgłoszenie złożone',
          },
          mitigationPlanReminder: 'Wymagane zatwierdzenie planu łagodzenia',
          staleCase: 'Niewykonany przypadek',
        },
        privacyStatement: 'Oświadczenie o prywatności',
        reporter: {
          myReports: 'Moje raporty',
        },
        settings: 'Ustawienia',
        technicalSupport: 'Wsparcie techniczne',
        title: 'Konto',
      },
      time: {
        day: 'Dzień',
        days: 'Dni',
        hour: 'Godzina',
        hours: 'Godziny',
        minute: 'Minuta',
        minutes: 'Minuty',
        second: 'Sekundę',
        seconds: 'Sekundy',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'Anonimowy',
        autoTranslate: 'Automatyczne tłumaczenie jest domyślnie wyłączone.',
        backToMessages: 'Powrót do wiadomości',
        caseSettings: 'Ustawienia przypadku.',
        changeInProfile:
          'Jeśli chcesz zmienić to ustawienie, możesz to zrobić w swoim profilu',
        deletedByMessage: 'Usunięte przez {{author}}',
        deletedMessageLabel: 'Ta wiadomość została usunięta',
        description:
          'Gdy włączona jest automatyczna tłumaczenie, wszystkie komunikaty z raportów będą \n          automatycznie tłumaczone za pomocą AI na podstawie domyślnego języka\n          wybranego w Twojej przeglądarce.',
        descriptionSecondHalf:
          'Oryginalna wersja wszystkich wiadomości jest zawsze zachowana i można ją znaleźć na czacie.',
        messagePlaceholder: 'Zacznij pisać...',
        messageSettings: 'Ustawienia wiadomości.',
        originalMessages: 'Oryginalny',
        showMoreBanner: 'Dowiedz się więcej o automatycznych tłumaczeniach',
        titlev2:
          'Czytaj wszystkie wiadomości w preferowanym przez Ciebie języku.',
        translatedMessageLabel: 'Przetłumaczona Wiadomość',
        translatedMessages: 'Przetłumaczony',
        understood: 'Rozumieć',
      },
      Country: {
        description: 'W jakim kraju Pani/Pan pracuje?',
        header: 'W jakim kraju Pani/Pan pracuje?',
        noOptions: 'Nie znaleziono krajów',
        other: 'Inne',
        placeholder: 'Wyszukaj kraj...',
      },
      CreatePublicReport: {
        createReport: 'Utwórz nowe zgłoszenie',
        helpPage: 'Przejdź do naszej strony pomocy',
        loginToOpr: 'Zaloguj się, aby śledzić raporty',
        or: 'lub',
        passwordPlaceholder: 'Wprowadź hasło',
        phoneNumberLoginFailed:
          'Logowanie nieudane, numer telefonu/kod PIN nieprawidłowy',
        phoneNumberPlaceholder: 'Wprowadź swój numer telefonu',
        phoneNumberTooltip:
          'Wprowadź numer telefonu, którego użyłeś do kontaktu z VaultTalk',
        pinPlaceholder: 'Wprowadź PIN',
        reportIntroductionParagraph1:
          'Podczas zgłaszania incydentu, zostaniesz poproszony o udzielenie kilku odpowiedzi, które pomogą Ci udokumentować Twoje doświadczenia.',
        reportIntroductionParagraph2:
          'Zanim wyślesz, masz opcję pozostania anonimowym, aby chronić swoją prywatność.',
        reportIntroductionParagraph3:
          'Po wysłaniu, możesz zalogować się w dowolnym momencie, aby zobaczyć postęp swojego raportu i porozmawiać z menedżerem ds. spraw.',
        reportIssue: 'Zgłoś problem',
        usernameLoginFailed:
          'Logowanie nieudane, nieprawidłowa nazwa użytkownika/hasło',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired:
              'Wymagane jest podanie relacji do firmy',
            reportedCategoryRequired: 'Wymagana jest kategoria zgłoszenia',
          },
        },
        vaultId: 'ID Vault',
        vaultIdPlaceholder: 'Wprowadź swój Email lub ID Vault',
        vaultIdTooltip:
          'Dla anonimowych zgłoszeń, ID Vault jest alfanumeryczne. Jeśli zgłoszenie nie było anonimowe, ID Vault to Twój adres email.',
        vaultTalk: 'VaultTalk',
        yourPassword: 'Twoje Hasło',
        yourPhoneNumber: 'Twój numer telefonu',
        yourPin: 'Twój 6-cyfrowy PIN',
        yourVaultId: 'Twoje ID Vault',
      },
      CustomHeader: {
        companyLogo: 'Logo firmy',
        openReporting: 'Otwórz zgłaszanie nieprawidłowości',
        userSettings: 'Ustawienia użytkownika',
      },
      Date: {
        approximateDescription: 'Czy pamiętasz mniej więcej datę zdarzenia?',
        approximatePlaceholder:
          'Przykład: 6 miesięcy temu / w zeszłym roku / w listopadzie',
        cancel: 'anuluj',
        clear: 'wyczyść',
        description: 'Czy pamiętasz datę zdarzenia?',
        header: 'Kiedy to się stało?',
        ok: 'ok',
        placeholder: 'Przykład: 21 czerwca 2020 r.',
      },
      Description: {
        whatHappened: 'Co się stało?',
        whatHappenedPlaceholder: 'Opisz to własnymi słowami...',
        whatHappenedText: 'Opisz zdarzenie własnymi słowami',
      },
      Details: {
        disclaimer:
          'Te szczegóły zostaną ujawnione wraz z twoim raportem. Jeśli chcesz pozostać anonimowy, upewnij się, że nie zawierają one informacji identyfikacyjnych.',
        emailPlaceholder: 'Adres e-mail (opcjonalnie)',
        fullNamePlaceholder: 'Imię i nazwisko (opcjonalnie)',
        header: 'Twoje dane',
        nonAnonSubtitle:
          'Proszę podać swoje imię lub adres e-mail. Jeśli chcesz otrzymywać powiadomienia na temat tego raportu, dodaj odpowiedni adres e-mail poniżej.',
        nonOptionalEmailPlaceholder: 'Email',
        nonOptionalFullNamePlaceholder: 'Pełne imię',
        subtitle:
          'Jeśli chcesz otrzymywać powiadomienia na temat tego raportu, dodaj odpowiedni adres e-mail poniżej.',
      },
      Emotion: {
        description:
          'Z jakimi uczuciami wiązało się dla Ciebie to zdarzenie? Jakie miało to konsekwencje?',
        header: 'Jakie miało to konsekwencje?',
        placeholder: 'Zacznij pisać...',
      },
      Evidence: {
        addedHeading: 'Dodany',
        deletedMessage: 'został usunięty',
        deletedStatus: 'Usunięty',
        failedToOpenFileMessage:
          'Nie udało się otworzyć pliku. Spróbuj ponownie.',
        fileStatuses: {
          infectedUpload: 'Oflagowany przez kontrolę bezpieczeństwa',
          passedUpload: 'Przeszedł kontrolę bezpieczeństwa',
          pendingUpload: 'Trwa kontrola bezpieczeństwa',
          readyForDownload: 'Gotowy do pobrania',
        },
        mobileErrorMessage:
          'Oflagowane pliki: wyślij wiadomość do swojego menedżera ds. spraw',
        nameHeading: 'Nazwa',
        statusHeading: 'Status',
        tableTitle: 'Dowody',
        webErrorMessage:
          'Oznaczone pliki: Jeśli Twój(e) plik(i) został(y) oznaczone, proszę o wiadomość do menedżera sprawy.',
      },
      FileUpload: {
        addFiles: 'Dodaj pliki',
        addMoreFiles: 'Dodaj więcej plików',
        confirm: 'Potwierdź',
        description:
          'Dodanie plików jako dowodów może pomóc w poprawie efektywności rozwiązywania spraw przez twojego menedżera ds. przypadków. Proszę rozważyć treść pliku (w tym metadane pliku), jeśli chcesz pozostać anonimowy, i szanuj prawa innych osób oraz obowiązujące prawa.',
        dragDrop: 'Upuść pliki tutaj lub',
        errorMessage:
          'Plik(i) nie został(y) załadowany(e) z powodu błędu sieci. Kliknij poniżej, aby wysłać wiadomość do swojego menedżera ds. spraw o pomoc.',
        fileLimit: 'Limit rozmiaru każdego pliku: 100MB',
        fileUploadLimitText: 'Możesz przesłać tylko 10 plików.',
        header: 'Dodaj dowody',
        helpArticle: 'artykuł pomocy',
        highlighted: 'Przeglądaj pliki',
        information: 'Obsługiwane typy plików',
        moreInformation:
          'Aby uzyskać więcej informacji, proszę zobaczyć tutaj. <a>artykuł pomocy</a>',
        postSubmissionErrorMessage:
          "Nie mogliśmy przesłać twoich plików z powodu błędu systemu. Proszę wybrać ponownie 'potwierdź'.",
        tooltipAudio: 'Audio:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: 'Dokumenty:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'Obrazy:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'Tekst:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: 'Wideo:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: 'Plik jest za duży',
          invalidFileType: 'Nieobsługiwany typ pliku: {{extension}}',
          systemError: 'Błąd systemu',
          tooManyFiles: 'Maksymalna liczba plików to {{maxFiles}}',
        },
        uploadFiles: 'Prześlij pliki',
      },
      Loading: {
        loading:
          'Proszę czekać, podczas gdy przesyłamy twój raport do menedżera sprawy...',
        postSubmissionLoading:
          'Proszę czekać, podczas gdy wysyłamy twój(e) plik(i)...',
      },
      Location: {
        description: 'Gdzie to się stało?',
        header: 'Gdzie to się stało?',
        placeholder: 'Przykład: w biurze',
      },
      MessageListBox: {
        messageCaseManager:
          'Wyślij wiadomość do kierownika zarządzającego zgłoszeniem',
        report: 'Zgłoszenie {{displayReportId}} {{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'Tłumaczenie wyłączone',
        enableTranslationLabelEnabled: 'Tłumaczenie włączone',
        enableTranslationsDescription:
          'Włącz automatyczne tłumaczenia i czytaj wszystkie wiadomości z raportów w preferowanym języku. Tłumaczony język jest oparty na języku wybranym na twoim urządzeniu.',
        enableTranslationsHeader:
          'Włącz automatyczne tłumaczenia dla wiadomości z raportów',
        enableTranslationsSubDescriptionv2:
          'Możesz przełączać się między przetłumaczonym a oryginalnym językiem w każdym czacie.',
        updateTranslationFailed: 'Aktualizacja tłumaczenia nie powiodła się',
        updateTranslationSuccess:
          'Ustawienia tłumaczenia zaktualizowane pomyślnie',
      },
      Password: {
        changePasswordHeader: 'Zmień hasło',
        createNewPassword: 'Utwórz nowe hasło',
        createPasswordHeader: 'Twoje hasło',
        currentPasswordPlaceholder: 'Wprowadź aktualne hasło',
        description:
          'Prawidłowe hasło musi składać się z co najmniej 9 znaków i zawierać jedną wielką literę i jedną cyfrę',
        enterCurrentPassword: 'Wprowadź aktualne hasło',
        forgottenPasswordInstructions:
          'Wprowadź swój alfanumeryczny identyfikator Vault (nie adres e-mail) i adres e-mail, aby zresetować hasło.',
        newDescription:
          'Utwórz silne hasło, aby zachować bezpieczeństwo swojego konta. Zacznij pisać, aby zobaczyć wytyczne poniżej.',
        passwordPlaceholder: 'Utwórz hasło',
        passwordResetRequestedDescription:
          'Jeśli twoje ID Vault istnieje w naszym systemie, otrzymasz e-mail z instrukcjami jak zresetować swoje hasło.',
        passwordResetRequestedHeader: 'Żądany link do resetowania hasła',
        reenterPlaceholder: 'Wprowadź hasło ponownie',
        subtitle:
          'Utwórz hasło, aby przesłać zgłoszenie i mieć do niego dostęp w przyszłości',
        yourVaultId: 'Twój ID Vaulta',
        yourVaultIdPlaceholder: 'Wprowadź swój ID Vault (np. {{exampleId}})',
      },
      Perpetrators: {
        description:
          'Czy zgłoszenie dotyczy jednej konkretnej osoby, czy też grupy osób? Czy możesz je wymienić lub opisać?',
        header: 'Osoby zaangażowane',
        placeholder:
          'Zacznij pisać i użyj przecinka, aby dodać wiele imion lub opisów',
      },
      PoweredByVault: 'Technologia dostarczona przez {{company}}',
      PrivacyStatement: 'Oświadczenie o Prywatności Produktu',
      PublicMessageList: {
        myMessages: 'Moje wiadomości',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader: 'Dowody dodane do istniejącego raportu',
        backToReportId: 'Powrót do raportu ID: {{reportId}}',
        description:
          'Dodanie plików jako dowodów może pomóc w zwiększeniu skuteczności rozwiązania przez twojego menedżera ds. przypadków. Prosimy o rozważenie zawartości pliku (w tym metadanych pliku), jeśli chcesz pozostać anonimowy, oraz o szanowanie praw innych osób i przestrzeganie obowiązujących praw. Aby uzyskać więcej informacji, prosimy o zapoznanie się z tym <a>artykuł pomocy</a>',
        header: 'Dodaj dodatkowe dowody do raportu',
        vaultTalkOpenCaseHeader: 'Dodaj dowody do swojego raportu',
      },
      PublicReport: {
        anonymous: 'Anonimowy',
        backToReports: 'Powrót do zgłoszeń',
        skipped: 'Pominięto',
      },
      PublicReportCard: {
        addEvidence: 'Dodaj dodatkowe dowody',
        messageCaseManager:
          'Wyślij wiadomość do kierownika zarządzającego zgłoszeniem',
        reportId: 'Identyfikator zgłoszenia:',
        submitted: 'Przesłano',
        vaultTalkClosedCaseCTA: 'Zobacz Dowody',
        vaultTalkOpenCaseCTA: 'Dodaj dowody',
        viewAdditionalEvidence: 'Zobacz dodatkowe dowody',
        viewReport: 'Utwórz nowe zgłoszenie',
      },
      PublicReportsList: {
        reportingSystem: 'System zgłaszania nieprawidłowości',
      },
      Question: {
        placeholder: 'Zacznij pisać...',
        question: 'Podaj szczegóły',
        questionText:
          'Proszę podzielić się z nami swoimi obawami, aktualizacjami lub zapytaniami.',
      },
      Relationship: {
        header: 'Twój związek z organizacją',
        tellUsAbout: 'Przedstaw nam swój związek z organizacją.',
      },
      ResponsiveNavMenu: {
        messages: 'Moje wiadomości',
        reports: 'Moje raporty',
      },
      Site: {
        description: 'W jakiej lokalizacji Pani/Pan pracuje?',
        header: 'W jakiej lokalizacji Pani/Pan pracuje?',
        noOptions: 'Nie znaleziono lokalizacji',
        other: 'Inne',
        placeholder: 'Wyszukaj lokalizację...',
      },
      SpamPuzzle: {
        dialog: 'Ułóż puzzle, aby kontynuować',
      },
      SubmissionTypes: {
        reportIssue: 'Wybierz kategorię',
        whatType: 'Wybierz kategorię, która najlepiej opisuje twój raport',
      },
      SubmitSuccess: {
        category: '<bold>Kategoria:</bold> {{category}}',
        country: '<bold>Kraj:</bold> {{country}}',
        dateSubmitted: '<bold>Data wysłania:</bold> {{date}}',
        recordYourVaultID: 'Zapamiętaj te informacje do logowania',
        successInformation: 'Więcej informacji',
        successMessage:
          'Twój raport został przesłany i jest gotowy do przeglądu. Wszystkie załączone pliki, które wymagają uwagi, zostaną oznaczone po zalogowaniu. Zaloguj się poniżej, aby wyświetlić aktualizacje raportu i wysłać wiadomość do swojego menedżera ds. przypadków.',
        successSanitationMessage:
          'Zachowaj kopię dla swoich rekordów i bezpiecznie przechowuj swój Vault-ID - będziesz go potrzebować, aby uzyskać dostęp do aktualizacji i wysyłać wiadomości do swojego menedżera ds. spraw.',
        successSanitationTagline:
          'Twój raport został przesłany i bezpiecznie przechowywany.',
        successThankYou: 'Dziękuję za twój raport!',
        viewReport: 'Zobacz raport',
      },
      Time: {
        approximateDescription: 'Czy pamiętasz mniej więcej godzinę zdarzenia?',
        approximatePlaceholder: 'Przykład: rano, po południu',
        description: 'Czy pamiętasz godzinę zdarzenia?',
        header: 'O której godzinie to się stało?',
        invalidTime: 'Data musi być zapisana w formacie HH:MM',
      },
      UserSettingsDialog: {
        changePassword: 'Zmień hasło',
        closeDialog: 'Zamknij okno dialogowe',
        logout: 'Wyloguj się',
        messageSettings: 'Ustawienia wiadomości',
        userSettings: 'Ustawienia użytkownika',
      },
      Witnesses: {
        description:
          'Czy powiedziałeś(-aś) o tym komuś innemu lub ktoś inny widział zdarzenie?',
        header: 'Czy byli przy tym świadkowie?',
        placeholder: 'Zacznij pisać...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'Wyślij wiadomość',
        title: 'Wiadomość Menedżer Sprawy',
        translationHeader: 'Dowiedz się więcej o automatycznych tłumaczeniach.',
      },
      ReportCard: {
        addEvidence: 'Dodaj dowody',
        submissionModeVia: 'za pośrednictwem {{submissionMode}}',
        viewEvidence: 'Zobacz dowody',
      },
      ReportList: {
        yourReports: 'Twoje Raporty',
      },
      ReportingActivate: {
        buttonText: 'Kontynuuj',
        description:
          'Jeśli twoja organizacja zarejestrowała cię na konto, wyślemy Ci e-mail z instrukcjami, jak dokończyć konfigurację.',
        emailInput: 'E-mail',
        header: 'Wprowadź swój służbowy adres email',
        successAccount:
          'Jeśli Twoja organizacja zarejestrowała Cię na konto, wyślemy Ci e-mail z instrukcjami dotyczącymi dokończenia konfiguracji.',
        successEmail:
          'Jeśli nie widzisz tego od razu, proszę zaczekać kilka minut i odświeżyć skrzynkę odbiorczą swojego e-maila.',
        successHeading: 'Dziękuję Ci',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'Dodaj dowody do swojego raportu',
        descriptionText:
          'Dodawanie plików jako dowodów może pomóc w poprawie efektywności rozwiązania przez twojego menadżera sprawy. Proszę rozważyć zawartość pliku (w tym metadane pliku), jeśli chcesz pozostać anonimowy, i szanować prawa innych osób oraz obowiązujące prawa. Aby uzyskać więcej informacji, proszę zobaczyć ten <a>artykuł pomocniczy</a>',
        emptyMessage: 'Brak dodatkowych dowodów dołączonych',
      },
      ReportingChangePassword: {
        back: 'Z powrotem',
        description:
          'Utwórz silne hasło, aby zapewnić bezpieczeństwo swojemu kontu. Zacznij pisać, aby zobaczyć wytyczne poniżej.',
        errorToast: 'Nie można utworzyć hasła, nieprawidłowy token.',
        header: 'Zmień hasło',
        incorrectCurrentPassword:
          'Bieżące hasło jest nieprawidłowe. Sprawdź je i spróbuj ponownie.',
        invalidToken: 'Nieprawidłowy token',
        passwordUpdated: 'Hasło zaktualizowane',
        passwordUpdatedDescription:
          'Twoje hasło zostało pomyślnie zaktualizowane. Dziękujemy za podjęcie tego kroku w celu zapewnienia bezpieczeństwa swoich danych!',
        passwordUsedBefore: 'Ponowne użycie hasła jest niedozwolone',
        passwordUsedBeforeDescription:
          'Dla Twojego bezpieczeństwa, nie możesz używać żadnego z sześciu ostatnich haseł. Proszę wybrać nowe, unikalne hasło, aby utrzymać swoje konto bezpiecznym i spróbować ponownie.',
        toastDescription:
          'Twoje hasło zostało pomyślnie zaktualizowane. Dziękujemy za podjęcie tego kroku w celu ochrony Twoich danych!',
        toastMessage: 'Hasło zaktualizowane',
        updatePasswordCTA: 'Aktualizuj hasło',
      },
      ReportingConnect: {
        cancelButton: 'Anuluj',
        connectButton: 'Połącz',
        disclaimer:
          'Podłączenie Twojego konta Slack do konta Vault zapewnia bezpieczne i prywatne połączenie.<br /><br />Dzięki temu połączeniu, możesz zgłaszać nadużycia lub zadawać pytania bezpośrednio w Slack. Zawsze masz możliwość zgłoszenia się anonimowo po połączeniu. Twoja prywatność i bezpieczeństwo są dla nas najważniejsze.',
        heading:
          'Platforma Vault prosi o zgodę na dostęp do Twojego konta Slack w {{organisationName}}',
        listHeading: 'Co będzie w stanie zrobić Vault?',
        permissionIdentity: {
          extraInfo:
            'Vault będzie miał możliwość przeglądania tożsamości twojego użytkownika Slack.',
          heading: 'Wyświetl informacje o tożsamości użytkownika',
        },
        permissionNotifications: {
          extraInfo:
            'Vault będzie mógł wysyłać powiadomienia na twoje konto Slack, dotyczące wszelkich aktualizacji wysłanego raportu lub pytania.',
          heading: 'Wysyłam Ci powiadomienia',
        },
        permissionOverview: {
          extraInfo:
            'Vault przedstawi na stronie głównej przegląd wszystkich zgłoszeń.',
          heading: 'Przegląd zgłoszeń',
        },
        permissionSubmitReport: {
          extraInfo:
            'To pozwoli Vaultowi na wysłanie raportu lub zadanie pytania bezpośrednio do twojej organizacji za pomocą Slacka.',
          heading: 'Złóż raport lub pytanie w swoim imieniu',
        },
        successfulConnectionDescription:
          'Twoje konto Vault i konto Slack są teraz połączone. Możesz teraz zamknąć tę kartę i wrócić do Slack.',
        successfulConnectionHeading: 'Pomyślnie połączony',
        unsuccessfulConnectionDescription:
          'Coś poszło nie tak. Zamknij tę kartę i wróć do Slacka, aby spróbować ponownie.',
        unsuccessfulConnectionHeading: 'Połączenie nieudane',
      },
      ReportingForgotPassword: {
        description:
          'Podaj adres e-mail powiązany z Twoim kontem, a my wyślemy Ci link do zresetowania hasła.',
        heading: 'Zapomniane hasło',
        invalidTokenError: 'Nie można utworzyć hasła, nieprawidłowy token.',
        passwordReuseError: 'Ponowne użycie hasła jest niedozwolone',
        passwordReuseErrorDescription:
          'Dla twojego bezpieczeństwa, nie możesz używać żadnego z ostatnich sześciu haseł. Wybierz nowe, unikalne hasło, aby utrzymać swoje konto bezpiecznym i spróbuj ponownie.',
        sendLink: 'Wyślij link do resetowania',
        sendLinkFailure: 'Coś poszło nie tak',
        sendLinkFailureDescription:
          'Wróć do <a>Centrum Reportera</a> i spróbuj ponownie. Jeśli problem nadal występuje, skontaktuj się z nami pod adresem <mailto>techsupport@vaultplatform.com</mailto>',
        sendLinkSuccess: 'Link do resetowania hasła został wysłany',
        sendLinkSuccessDescription:
          'Wysłaliśmy link do resetowania hasła na adres {{email}}',
        updatePasswordSuccess: 'Hasło zaktualizowane',
        updatePasswordSuccessDescription:
          'Twoje hasło zostało pomyślnie zaktualizowane. Dziękujemy za podjęcie tego kroku w celu ochrony swoich danych!',
      },
      ReportingLogin: {
        accountFrozen: 'Konto jest zamrożone',
        accountLocked:
          'Próbowano zalogować się zbyt wiele razy niepoprawnie. Konto jest zablokowane na okres do 1 godziny. Resetowanie hasła nie jest możliwe w tym czasie.',
        accountLockedPermanently:
          'Twoje konto zostało zablokowane. Użyj opcji resetowania hasła, aby odzyskać dostęp lub skontaktuj się z administratorem systemu w celu uzyskania dalszej pomocy.',
        createAccountCTA: 'Zarejestruj się na konto',
        currentPassword: 'Aktualne hasło',
        emailLabel: 'Twój Email',
        forgotPassword: 'Zapomniałeś swojego hasła?',
        loginButton: 'Zaloguj się',
        newPasswordPlaceholder: 'Nowe hasło',
        passwordFailMessage:
          'Wróć do aplikacji Vault w Slacku i spróbuj ponownie. Jeśli problem nadal występuje, skontaktuj się z nami pod adresem techsupport@vaultplatform.com',
        passwordFailTitle: 'Coś poszło nie tak',
        passwordLabel: 'Twoje Hasło',
        passwordPlaceholder: 'Wprowadź swoje hasło',
        passwordResetRequired: 'Wymagane zresetowanie hasła',
        passwordSuccessfullySetMessage:
          'Wróć do aplikacji Vault w Slacku i uwierzytelnij się za pomocą swojego nowego hasła, aby kontynuować tam, gdzie skończyłeś.',
        passwordSuccessfullySetTitle: 'Hasło zostało pomyślnie ustawione',
        reenterPlaceholder: 'Wprowadź hasło ponownie',
        title: 'Reporter Hub',
        tooltip:
          'Jeśli nigdy nie ustawiłeś hasła dla aplikacji Vault, postępuj zgodnie z instrukcjami tutaj, aby rozpocząć. Jeśli zapomniałeś swojego hasła, skorzystaj z linku "Zapomniałem hasła" poniżej.',
        usernameLoginFailed:
          'Logowanie nie powiodło się, nazwa użytkownika lub hasło są nieprawidłowe',
      },
      ReportingReset: {
        failureDescription:
          'Wróć do aplikacji Vault w Slacku i spróbuj ponownie. Jeśli problem będzie się powtarzał, skontaktuj się z nami pod adresem <mailto>techsupport@vaultplatform.com</mailto>',
        failureHeading: 'Coś poszło nie tak',
        successDescription:
          'Wróć do aplikacji Vault w Slack i uwierzytelnij się przy użyciu nowego hasła, aby kontynuować tam, gdzie skończyłeś.',
        successHeading: 'Hasło zostało pomyślnie ustawione',
      },
      noReports: {
        description:
          'Wszystkie przesłane raporty pojawią się tutaj. Dowiedz się więcej o sposobach, w jaki możesz przesłać raport w',
        descriptionHelpArticle: 'ten artykuł pomocy',
        errorDescription:
          'Walczymy z załadowaniem twoich raportów. Proszę spróbować odświeżyć stronę.',
        errorDescriptionSecondary:
          'Jeśli to nie zadziała, prosimy o kontakt z nami pod adresem',
        errorTitle: '⚠️ Ups, coś poszło nie tak',
        title: 'Nie masz jeszcze żadnych raportów',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'Włącz automatyczne tłumaczenia i czytaj wszystkie wiadomości z raportu w swoim preferowanym języku. Tłumaczony język jest oparty na języku wybranym na Twoim urządzeniu.',
          autoTranslationDescription2:
            'Możesz przełączać się między tłumaczonym a oryginalnym językiem w każdej rozmowie.',
          autoTranslationTitle:
            'Włącz automatyczne tłumaczenia dla wiadomości z raportów',
          header: 'Ustawienia wiadomości',
          subHeader: 'Konfiguruj sposób wyświetlania wiadomości',
        },
        notificationSettings: {
          emailDescription:
            'Otrzymuj powiadomienia e-mail o ważnych aktualizacjach swoich raportów',
          emailTitle: 'Powiadomienia email',
          header: 'Ustawienia powiadomień',
          subHeader: 'Skonfiguruj, jak otrzymujesz powiadomienia',
        },
        title: 'Ustawienia',
        updatedSettingsFailure: 'Nie udało się zaktualizować twoich ustawień',
        updatedSettingsSuccess: 'Pomyślnie zaktualizowano twoje ustawienia',
      },
    },
    validators: {
      passwordLength: 'Hasło musi składać się z co najmniej 9 znaków',
      passwordLowercase: 'Hasło musi zawierać co najmniej 1 małą literę',
      passwordMissMatch:
        'Pole hasła i pole potwierdzenia muszą być identyczne.',
      passwordNumeric: 'Hasło musi zawierać co najmniej 1 cyfrę',
      passwordUppercase: 'Hasło musi zawierać co najmniej 1 wielką literę',
    },
    validatorsNew: {
      passwordLength: 'Między 10 a 30 znakami',
      passwordLowercase: 'Przynajmniej jedna mała litera',
      passwordMissMatch: 'Hasła nie są zgodne',
      passwordNumeric: 'Przynajmniej jedna liczba',
      passwordSpecialCharacter: 'Przynajmniej jeden znak specjalny',
      passwordUppercase: 'Przynajmniej jedna wielka litera',
    },
  },
};

export default translations;
